<template>
	<div class="col-12 pl-0 pr-0">
		<div class="col-12 pl-0 pr-0" v-if="step == 3">
			<div class="col-12 pl-md-4 pr-md-4 pt-2 pb-2 bg-light-blue mt-3 color-white cus-box-shadow rounded-cus font-size-10 d-flex">
				<i class="fas fa-box-open mt-auto mb-auto"></i>
				<div class="pl-2">Silahkan pilih metode pembayaran Anda agar pembayaran anda dapat diproses</div>
			</div>
			<div class="col-12 pl-md-4 pr-md-4 pt-3 pt-md-4 pb-4 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap">
				<div class="col-lg-5 pl-0 pr-0 pr-md-2" v-if="dataSerial.length > 0">
					<div v-if="serialType == 1">
						<div class="col-12 pl-0 pr-0 pb-3" v-for="(data, index) in dataSerial" :key="index">
							<div class="col-12 mt-1 font-size-10 label-detail-product-serial">{{data.product_code}}</div>
							<div class="col-12 mt-1 font-size-10 label-detail-product-serial">Serial {{serialOptionName[data.type]}} Terpilih ({{data.serial.length}})</div>
							<div class="col-12 mt-2 pt-2 pb-4 bg-white border-2 rounded-cus box-selected-serial">
								<div class="col-12 pl-0 pr-0 font-size-10" v-for="(value, index) in data.serial_carton" :key="index">
									<div class="col-12 pt-2 pl-0 pr-0">{{value}}</div>
									<div class="col-12 pt-2 border-bottom"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-5 pl-0 pr-0 pr-md-2" v-else>
					<div class="col-12 pl-0 pr-0 pb-3">
						<div class="col-12 mt-2 pt-2 pb-4 bg-white border-2 rounded-cus box-selected-serial">
							<div class="col-12 pl-0 pr-0 font-size-10" >
								<div class="col-12 pt-2 pl-0 pr-0">Tidak ada serial terplih</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-7 pl-0 pr-0">
					<div class="col-12 pl-0 pr-0 d-flex font-size-10">
						<div class="col-6 pl-0 pr-0 pl-md-3 mt-auto mb-auto font-size-sm-9">Metode Pembayaran</div>
						<div class="col-6 pl-2 pr-0">
							<v-select @search:blur="tepilih" label="text" class="font-size-10 font-size-sm-9 pt-1 pb-1" :options="payment" v-model="selected">
							</v-select>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 mt-md-3 d-flex font-size-10" v-if="selected.value == 4">
						<div class="col-6 pl-0 pr-0 pl-md-3 mt-auto mb-auto font-size-sm-9">Bank</div>
						<div class="col-6 pl-2 pr-0">
							<v-select label="text" class="font-size-10 font-size-sm-9 pt-1 pb-1" :options="bank" v-model="selectedPayment">
							</v-select>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 mt-1 mt-md-3 d-flex font-size-10" v-if="selected.value == 4">
						<div class="col-6 pl-0 pr-0 pl-md-3 mt-auto mb-auto font-size-sm-9">Nomor Kartu</div>
						<div class="col-6 pl-2 pr-0">
							<input class="form-control form-control-sm box-blue rounded-cus font-size-10 font-size-sm-9" type="text" placeholder="Nomor Kartu">
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 mt-1 mt-md-3 d-flex font-size-10" v-if="selected.value == 4">
						<div class="col-6 pl-0 pr-0 pl-md-3 mt-auto mb-auto font-size-sm-9">Masa Berlaku</div>
						<div class="col-6 pl-2 pr-0 d-flex">
							<div class="col-5 pl-0 pr-0">
								<v-select label="text" class="font-size-10 font-size-sm-9 pt-1 pb-1" :options="month">
								</v-select>
							</div>
							<div class="pl-1 pr-1 m-auto">/</div>
							<div class="col-6 pl-0 pr-0">
								<v-select label="text" class="font-size-10 font-size-sm-9 pt-1 pb-1" :options="year">
								</v-select>
							</div>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 mt-1 mt-md-3 d-flex font-size-10">
						<div class="col-6 pl-0 pr-0 pl-md-3 mt-auto mb-auto font-size-sm-9">Total Tagihan</div>
						<div v-if="!mitra || register" class="col-6 pl-2 pr-0 mt-auto mb-auto font-size-11 text-right">{{price_total + registerItem.price_total + shipping_cost | toRupiah}}</div>
						<div v-else class="col-6 pl-2 pr-0 mt-auto mb-auto font-size-11 text-right">{{price_total + shipping_cost | toRupiah}}</div>
					</div>
					<!-- <div class="col-12 pl-0 pr-0 mt-2 mt-md-3 d-flex font-size-10" v-show="selected.value == 3">
						<div class="col-6 pl-0 pr-0 pl-md-3 mt-auto mb-auto font-size-sm-9">Jumlah Pembayaran (Rp)</div>
						<div class="col-6 pl-2 pr-0">
							<input @paste.prevent @keypress="onlyNumber" v-rupiahFormat="pay_total" ref="pay_total" v-model="pay_total" class="form-control form-control-sm box-blue rounded-cus font-size-10 text-right" type="text" placeholder="0">
						</div>
					</div>
					<div class="col-12 pr-0 mt-4">
						<div class="border-bottom"></div>
					</div>
					<div class="col-12 pl-0 pr-0 pb-3 mt-4 d-flex font-size-10" v-if="total_pay > 0">
						<div class="col-6 pr-0 mt-auto mb-auto">Kembalian</div>
						<div class="col-6 pr-0 mt-auto mb-auto font-size-12 text-right">{{ kembalian | toRupiah}}</div>
					</div> -->
				</div>
			</div>
		</div>
		<transition name="slide-fade">
			<div class="col-12 pl-0 pr-0">
				<div class="col-12 pt-3 pl-md-4 pr-md-4 pt-md-4 pb-2 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap" v-if="step == 4">
					<div class="col-lg-6 pl-0 pr-0 pr-md-2" v-for="(data, index) in dataSerial" :key="index">
						<div class="col-12 pl-0 pr-0 pb-3"  v-if="serialType == 1">
							<div class="col-12 mt-1 font-size-10 label-detail-product-serial">{{data.product_code}}</div>
              <div class="col-12 mt-1 font-size-10 label-detail-product-serial">Serial {{serialOptionName[data.type]}} Terpilih ({{data.serial.length}})</div>
							<div class="col-12 mt-2 pt-2 pb-4 bg-white border-2 rounded-cus box-selected-serial">
								<div class="col-12 pl-0 pr-0 font-size-10" v-for="(value, index) in data.serial_carton" :key="index">
									<div class="col-12 pt-2 pl-0 pr-0">{{value}}</div>
									<div class="col-12 pt-2 border-bottom"></div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 pt-2 pb-3">
						<div v-if="register" class="col-12 text-center font-size-11 font-weight-bold">Link pendaftaran atas nama {{registrationData.name}} telah dikirim ke {{registrationData.mobilephone}}</div>
						<div v-else class="col-12 text-center font-size-11 font-weight-bold">Transaksi Berhasil Diproses!</div>
						<div class="col-12 text-center font-size-11">Silahkan menyiapkan produk yang dibeli Mitra Milagros.</div>
						<div class="col-8 ml-auto mr-auto mt-4">
							<img class="img-fluid" src="/assets/transaction/ilustrasi-transaksi-berhasil.png">
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import vSelect from "vue-select";
import { mapState, mapActions, mapMutations} from 'vuex';

export default {
	components: {
		vSelect
	},
	data() {
		return {
			success: true,
			bank: [{
				text: "Bank-bank tut",
				value: 0
			}, {
				text: "Bank Toyib",
				value: 1
			}],
			payment: [{
				text: "Tunai",
				value: 3
			// }, {
			// 	text: "Kartu Kredit",
			// 	value: 4
		}],
		month: [{
			text: "01",
			value: 1
		}, {
			text: "02",
			value: 2
		}],
		year: [{
			text: "2020",
			value: 0
		}, {
			text: "2021",
			value: 1
		}],
		selected: {
			text: "Tunai",
			value: 3
		},
		selectedBank: "",
		pay_total: '',
	}
},
props: {
	registrationData: {
		type: Object
	},
},
computed: {
	...mapState('cart', ['cart', 'dataSerial', 'selectedPayment', 'step', 'register', 'registerItem', 'mitra', 'serialOptionName', 'serialType', 'shipping_cost']),

	// kembalian() {
	// 	var uang_kembalian = 0
	// 	var total_pay = parseInt(this.pay_total.replace(/\D/g, ""))
	// 	if(!this.mitra || this.register) {
	// 		uang_kembalian =  total_pay - this.price_total - this.registerItem.price_total
	// 	} else {
	// 		uang_kembalian =  total_pay - this.price_total
	// 	}
	// 	if (uang_kembalian < 0) {
	// 		return 0
	// 	} else {
	// 		return uang_kembalian
	// 	}
	// },
	price_total(){
		let price_total = 0
		if(this.cart){
			this.cart.forEach(el => {
				price_total += parseInt(el.product_price) * parseInt(el.quantity)
			});
		}
		return price_total;
	},
	// total_pay() {
	// 	return this.pay_total.replace(/\D/g, "")
	// }
},
methods:{
	...mapActions('cart', ['formatSerialString']),
	...mapMutations('cart', ['setPayment', 'setPayTotal']),

	tepilih(){
		this.setPayTotal(0)
		// if (this.selected.value == 3) {
		// 	this.setFocus()
		// }
	},
	// setFocus(){
	// 	this.$refs.pay_total.focus()
	// }
},
watch: {
	// selected(){
	// 	this.setPayment(this.selected)
	// 	this.pay_total = ''
	// 	if (this.selected.value == 3) {
	// 		this.setFocus()
	// 	}
	// },
	// pay_total(){
	// 	this.setPayTotal(this.pay_total)
	// }
},
created(){
	if (this.dataSerial.length > 0) {
		this.formatSerialString(this.dataSerial)
	}
},
mounted(){
	// this.setFocus()
}
};
</script>
